
import { CVStyled } from './cv-style';
import CV_PDF from "../../common/assets/Rishikesh_Khakurel_CV.pdf"

export const CV = () => {

  return (
    <CVStyled>
        <iframe
        src={CV_PDF}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title='cv'
        />
      </CVStyled>
  );
};